import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import SoundType from "../../../core/sound/util/SoundType";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import MovieClipUtil from "../../util/MovieClipUtil";

export default class GenericOnboardingStepMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     * @param {SoundManager} soundManager 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, soundManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._soundManager = soundManager;

        /** @type {string} */
        this._stepId = ``;
    }

    initialize() {
        super.initialize();

        this._target.coachPanel.initialY = this._target.coachPanel.y;
        this._coachSlice9Panel = new Slice9Panel(this._target.coachPanel, MovieClipUtil.getFirstBitmapChild(this._target.coachPanel), {
            mode: Slice9Panel.VERTICAL,
            overlap: true,
            pixelPerfect: false,
        });
        this._target.coachPanel.alpha = 0;

        this._playAnimationSequence();
    }

    setStepId(stepId) {
        this._stepId = stepId;

        this._target.coachPanel.contentTextField.text = this._languagePack.getText(`onboarding.step.${this._stepId}.coach`);
        this._coachSlice9Panel.update();
        this._target.coachPanel.y = this._target.coachPanel.initialY - this._coachSlice9Panel.getDeltaHeight();
    }

    async _playAnimationSequence() {
        this._target.coachButton?.play();
        await createjs.Tween.get(this._target.coachPanel)
            .wait(250)
            .call(() => this._soundManager.playSound(SoundType.COACH_CHAT_BOX))
            .to({ alpha: 1 }, 450, createjs.Ease.sineInOut)
            .toPromise();

        this._target.arrow?.play();
    }
}